import generateAsyncRouteComponent from '../generateAsyncRouteComponent';

export default {
  path: 'shops',
  component: generateAsyncRouteComponent({
    loader: () => import('./containers/ShopsLandingPageContainer'),
  }),
};
